<template>
  <!-- Add Contact -->
  <div class="modal custom-modal fade custom-modal-two modal-padding" id="show_location" role="dialog">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header header-border justify-content-between p-0">
          <h5 class="modal-title">Location on map</h5>
          <button type="button" ref="Close" class="btn-close position-static" data-bs-dismiss="modal"
            aria-label="Close">
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body p-0">
          <div class="add-info-fieldset">
            <div class="contact-input-set">
              <div class="row">

                <div class="col-md-12">
                  <!-- Container for the map -->
                  <div id="map"></div>
                  <!-- <p>Lat: {{ lat }}</p>
                      <p>Lng: {{ lng }}</p> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Add Contact -->
  <!-- /update Contact -->
  <div class="modal custom-modal fade custom-modal-two modal-padding" id="update_location" role="dialog">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header header-border justify-content-between p-0">
          <h5 class="modal-title">Update Location</h5>
          <button type="button" ref="Close" class="btn-close position-static" data-bs-dismiss="modal"
            aria-label="Close">
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body p-0">
          <div class="add-info-fieldset">
            <div class="contact-input-set">
              <div class="row">

                <div class="col-md-6">
                  <div class="input-block mb-3">
                    <label class="col-form-label">Location <span class="text-danger"> *</span></label>
                    <input class="form-control" type="text" v-model="locationName" />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="input-block mb-3">
                    <label class="col-form-label">GeoLocation Radius(in meters) <span class="text-danger">
                        *</span></label>
                    <input class="form-control" type="text" v-model="locationRadius" />
                  </div>
                </div>
                <div class="col-md-12">
                  <!-- Container for the map -->
                  <div id="map"></div>
                  <!-- <p>Lat: {{ lat }}</p>
                      <p>Lng: {{ lng }}</p> -->
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /update Contact-->
</template>

<style scoped>
#map {
  width: 100%;
  height: 50vh;
}
</style>

<script>
import axios from "axios";
import { ref } from 'vue';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import markerIcon from '@/assets/img/icons/marker.png';
import "leaflet-geosearch/dist/geosearch.css";
import { GeoSearchControl, OpenStreetMapProvider } from "leaflet-geosearch";
import { VUE_APP_API_BASE_URL } from "../../config";
import draggable from "vuedraggable";

// import 'leaflet-control-geocoder/dist/Control.Geocoder.js';  // For search functionality
// import "leaflet-control-geocoder/dist/Control.Geocoder.css";

export default {
  data() {
    const myIcon = L.icon({
      iconUrl: markerIcon,
      iconSize: [32, 32]
    });
    return {
      lat: 0.14405508452768728,
      lng: 51.4893335,
      map: null,
      myIcon,
      locationName: '',
      locationRadius: null,
      marker: null,
      data: '',
      // searchQuery,
      // searchAddress,
    };
  },

  mounted() {
    // Set up the map

  },

  beforeUnmount() {
  if (this.map) {
    this.map.off(); // remove listeners
    this.map.remove(); // destroy
    this.map = null;
    this.marker = null;
  }
},

  methods: {
    updateValues(data) {
      if (this.map) {
        this.map.remove();
      }
      console.log('2', data, data.latitude, data.longitude);
      this.lat = data.latitude ?? 0.14405508452768728;
      this.lng = data.longitude ?? 51.4893335;

      this.map = L.map('map').setView([this.lat, this.lng], 3);

      // Add OpenStreetMap tile layer
      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        minZoom: 1, maxZoom: 18,
        zoomAnimation: false
      }).addTo(this.map);

      // Set up draggable marker
      this.marker = L.marker([this.lat, this.lng], { draggable: true, icon: this.myIcon }).addTo(this.map);

      this.map.on('click', (e) => {
        setTimeout(() => {
          this.map.invalidateSize();
        }, 1);

        this.lat = e.latlng.lat;
        this.lng = e.latlng.lng;
        // this.marker.setLatLng([this.lat, this.lng], { draggable: true, icon: this.myIcon });  // Update marker position
        this.map.setView([this.lat, this.lng], 3);
      });

      // Update latitude and longitude when marker is dragged
      this.marker.on('dragend', () => {
        // setTimeout(() => {
        //   this.map.invalidateSize();
        // }, 1);
        let position = this.marker.getLatLng();
        this.lat = position.lat;
        this.lng = position.lng;
      });

      // Create a geocoding search box using the OpenStreetMap provider
      const provider = new OpenStreetMapProvider();

      // Add the search control to the map
      let searchControl = GeoSearchControl({
        provider: provider,
        showMarker: false,
        showPopup: false,
      });
      this.map.addControl(searchControl);

      // Optional: Add a marker when the search returns a result
      this.map.on("geosearch/showlocation", (e) => {
        this.lat = e.location.x;
        this.lng = e.location.y;
        setTimeout(() => {
          this.map.invalidateSize();
        }, 1);
        this.marker.setLatLng([this.lat, this.lng], { draggable: true, icon: this.myIcon });  // Update marker position
        this.map.setView([this.lat, this.lng], 3);
      });

    },


  }
};
</script>
